define.alias("shared/components/shared/media-items/media-item", "media/components/shared/media-items/media-item");